
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user",
      function () {
        return require("private-next-pages/user.tsx");
      }
    ]);
  